import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-our-partners',
    templateUrl: './our-partners.component.html',
    styleUrls: ['./our-partners.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class OurPartnersComponent {}
